import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpProviderService } from '@core/service';
import {
  HttpRequestPayload,
  IHttpSuccessPayload,
  IHttpErrorPayload,
} from '@core/models';

@Injectable()
export class BranchesService {
  constructor(private httpProvider: HttpProviderService) {}

  fetchBranches(bankCode: any): Observable<any[]> {
    const request: HttpRequestPayload = {
      resource: `/branches`,
      queryParams: [
        {
          key: 'bankCode',
          value: bankCode,
        },
        {
          key: 'lookup',
          value: '1',
        },
      ],
      method: 'GET',
    };

    return this.httpProvider.invokeApi(request).pipe(
      map((response: IHttpSuccessPayload<any>) => {
        return response.body.Data;
      }),
      catchError((err: IHttpErrorPayload) => {
        return throwError(err);
      })
    );
  }
}
